import React from "react";

import Searchbar from "../../utils/searchbar/Searchbar";
import SearchOrganizations from "../../search/SearchOrganizations";

class OrganizationsSearch extends React.PureComponent {
	render() {
		return (
			<React.Fragment>
				<Searchbar
					placeholder={"Search organizations"}
					component={SearchOrganizations}
					searchEndpoint={"search/organizations"}
					basePath={this.props.location.pathname + "/edit"}
					{...this.props}
					userType="admin"
				/>
			</React.Fragment>
		);
	}
}

export default OrganizationsSearch;



// WEBPACK FOOTER //
// ./src/components/admin/organizations/OrganizationsSearch.js